import { Close } from '@mui/icons-material'
import { Box, Drawer, IconButton, Popover, PopoverProps, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { AnalyticsMetric } from '../../../types/Metrics'
import { useMetricServerConnection } from './hooks'
import { MetricList } from './MetricList'

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(3),
  },
  contentDesktop: {
    minWidth: 400,
    maxWidth: 600,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  drawerPaper: {
    width: '100%',
  },
}))

type MetricConnectionProps = {
  resortId: string
}

const MetricConnection = ({ resortId }: MetricConnectionProps): null => {
  useMetricServerConnection(resortId)
  return null
}

interface MetricCardsGridProps {
  open: boolean
  onClose: () => void
  metrics: AnalyticsMetric[]
  resortId: string
  isMobile: boolean
  anchorEl?: PopoverProps['anchorEl']
}

const MetricCardsGrid = ({ open, onClose, metrics, resortId, isMobile, anchorEl }: MetricCardsGridProps) => {
  const classes = useStyles()

  const content = open && (
    <Box className={`${classes.content} ${!isMobile ? classes.contentDesktop : ''}`}>
      <MetricConnection resortId={resortId} />

      <Box className={classes.header}>
        <Typography variant="h4">Metrics</Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </Box>

      <MetricList variant="grid" metrics={metrics} />
    </Box>
  )

  if (isMobile) {
    return (
      <Drawer anchor="right" variant="temporary" open={open} onClose={onClose} PaperProps={{ className: classes.drawerPaper }}>
        {content}
      </Drawer>
    )
  }

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      {content}
    </Popover>
  )
}

export default MetricCardsGrid
